// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"1284a4f8","117":"5c4ad993","161":"eb4bc315","209":"32193747","478":"ad1571d0","625":"027da181","675":"f8af8665","745":"4cdb9fc4","922":"a9748d02","964":"0937b954"}[chunkId] + ".chunk.js";
};